import { PropertyDocViewComponent } from '@/components/property-doc-view/property-doc-view.component';
import { ObjectUpdatedType } from '@/enums/ObjectUpdatedType.enum';
import { AppConfigService } from '@/services/app-config.service';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PropertyCategory, RealProperty } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { PropertyAttributesViewComponent } from '../../../components/property-attributes-view/property-attributes-view.component';
import { PropertyDocViewComponent as PropertyDocViewComponent_1 } from '../../../components/property-doc-view/property-doc-view.component';

@Component({
  selector: 'app-property-condo',
  templateUrl: './property-condo.component.html',
  styleUrls: ['./property-condo.component.scss'],
  standalone: true,
  imports: [PropertyAttributesViewComponent, PropertyDocViewComponent_1]
})
export class PropertyCondoComponent implements OnInit, OnDestroy {
  @ViewChild(PropertyDocViewComponent) docComponent: PropertyDocViewComponent;
  @Input() prop: RealProperty;

  sub = new Subscription();

  category = PropertyCategory.CONDOMINIUM;
  constructor(private appConfigService: AppConfigService) {}

  ngOnInit() {
    this.sub = this.appConfigService.objectUpdated.subscribe((type) => {
      if (type === ObjectUpdatedType.DOC) {
        this.refreshDocList();
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  refreshDocList() {
    if (this.docComponent) {
      this.docComponent.loadDocList();
    }
  }
}
